import config from "configs";

const { CLIENT_ID_LISA, ISSUER_LISA } = config.okta;

export default {
    clientId: CLIENT_ID_LISA,
    issuer: ISSUER_LISA,
    redirectUri: `${window.location.origin}/callbacklisa`,
    scopes: ["openid", "profile", "email", "groups"],
    response_type: "code",
    // pkce: false,
    tokenManager: {
        storageKey: 'okta-token-lisa',
        autoRenew: true,
        // autoRefresh: true,
        expireEarlySeconds: 10
    }
};
